import { render, staticRenderFns } from "./AssessetReview.vue?vue&type=template&id=3f17481d&scoped=true"
import script from "./AssessetReview.vue?vue&type=script&lang=js"
export * from "./AssessetReview.vue?vue&type=script&lang=js"
import style0 from "./AssessetReview.vue?vue&type=style&index=0&id=3f17481d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f17481d",
  null
  
)

export default component.exports